const STORAGE_KEY = 'mhj-search-attribution'

type AttributionStore = Record<string, string>

const isTermEntry = (entry: [string, unknown]): entry is [string, string] => isString(entry[1])

const read = (): AttributionStore => {
  try {
    const parsed: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
    // Session storage is untrusted: valid JSON of the wrong shape would break writes downstream.
    if (!isRecord(parsed)) return {}
    return Object.fromEntries(Object.entries(parsed).filter(isTermEntry))
  } catch {
    return {}
  }
}

const write = (store: AttributionStore) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store))
  } catch {
    // storage unavailable; attribution is best-effort
  }
}

export const useSearchAttribution = () => {
  if (!import.meta.client) {
    return { attributeSearchClick: () => {}, getAttributedTerm: () => undefined, clearSearchAttribution: () => {} }
  }

  const attributeSearchClick = (term: string, ids: (string | undefined)[]) => {
    const keys = ids.filter((id): id is string => !!id)
    if (!term || !keys.length) return

    const store = read()
    keys.forEach((key) => (store[key] = term))
    write(store)
  }

  const getAttributedTerm = (ids: (string | undefined)[]) => {
    const store = read()
    for (const id of ids) {
      if (id && store[id]) return store[id]
    }
  }

  const clearSearchAttribution = () => {
    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      // storage unavailable; nothing to clear
    }
  }

  return { attributeSearchClick, getAttributedTerm, clearSearchAttribution }
}
